












































































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Source } from '@/api/model/source'
import { SourceAPI } from '@/api/backend-client'
import KvButton from '@/components/input/KvButton.vue'
import InputSwitch from '@/components/input/InputSwitch.vue'
import TooltipDecorator from '@/components/input/label/decorator/TooltipDecorator.vue'
import { Company } from '@/api/model/company'

@Component({
    components: {
        KvButton,
        InputSwitch,
        TooltipDecorator,
    },
})
export default class EditSourceForm extends Vue {
    @Prop({ required: true }) readonly value!: Source
    @Prop({ required: true }) readonly sources: Source[]
    @Prop({ type: Boolean, default: false }) readonly isNew!: boolean
    saving: boolean = false
    inUse: boolean = false
    name: string = null
    active: boolean = false

    mounted(): void {
        this.applyInitialValue()
    }

    @Watch('value')
    applyInitialValue(): void {
        this.name = this.value?.name
        this.active = this.value?.active
    }

    async onSave(): Promise<void> {
        try {
            const value = this.updatedValue
            this.saving = true

            if (this.isNew) {

                // adding company to Source throws json recursion errors, so we inject it only here
                await SourceAPI.create({
                    company: this.$currentCompany.resourceIdentifier,
                    ...value,
                } as unknown as Source)

            } else {
                await SourceAPI.update(value.id, value)
            }

            this.$emit('save', this.updatedValue)

        } catch (error) {
            this.$notify({
                type: 'error',
                title: this.$t('forms.editSourceForm.saveError.title').toString(),
                text: this.$t('forms.editSourceForm.saveError.text').toString(),
            })
        }
    }

    async onCancel(): Promise<void> {
        this.$emit('cancel', this.updatedValue)
    }

    async onDelete(): Promise<void> {
        if (!confirm(this.$t('forms.editSourceForm.confirmDelete').toString())) {
            return
        }

        try {
            this.saving = true
            await SourceAPI.delete(this.value.id)
            this.saving = false
        } catch (error) {
            if (error.response && error.response.status === 405) {
                this.inUse = true
                this.saving = false
                return
            }
        }

        this.$emit('delete', this.updatedValue)
    }

    get updatedValue(): Source {
        return Source.fromData({
            ...this.value,
            name: this.name,
            active: this.active,
        })
    }

    get errors(): string[] {
        if (!this.value || this.name === null) {
            return []
        }

        const errors: string[] = []
        const hasSourcesWithSameName = this.sources
            .filter(source => source.id !== this.value.id)
            .some(source => source.name.toLowerCase() === this.name.toLowerCase())

        if (hasSourcesWithSameName) {
            errors.push(this.$t('forms.editSourceForm.error.alreadyExists').toString())
        }

        return errors
    }
}
